import { useEffect } from "react";

const PmirewardsVideo = () => {
//   useEffect(() => {
//     window.parent.postMessage(
//       { action: "redirectTo", label: "points-history" },
//       "*"
//     );
//   }, []);

  return (
    <iframe
      src="https://pmi-salesforce.videomarketingplatform.co/v.ihtml/player.html?token=fedc75c24f67f42590d2f3807721651e&source=embed&photo_id=118727395&endOn=thumbnail"
      width="100%"
      height="600"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};

export default PmirewardsVideo;
